import React, { useState, useEffect } from 'react';
import { useLatestLevelFromPageNow } from '~/inventory/bin-props';
import { Skeleton } from '~/lib/bn-material-ui';
import { entityStore, useSirenEntity } from '~/utility/BinSentry-ui-utility';

export function BinLevelImage({ levelEntity, imageClassName }) {
  const imageSrc = useBinLevelImageSrc({ levelEntity });
  return imageSrc
    ? <img src={imageSrc} alt='amplitude' style={{ width: '100%', verticalAlign: 'middle' }} className={imageClassName} />
    : <Skeleton style={{ width: '100%', height: '100%' }} />;
}

export function useBinLevelImageSrc({ levelEntity }) {
  const [imageSrc, setImageSrc] = useState();
  const { entity: threeDImagesEntity } = useSirenEntity({ href: levelEntity?.getSubEntity('https://api.binsentry.com/rel/3d-images')?.href });
  const amplitudeImageHref = threeDImagesEntity?.getSubEntity('https://api.binsentry.com/rel/amplitude-image')?.href;

  useEffect(() => {
    const fetchData = async () => {
      const headers = new Headers({ Authorization: `Bearer ${(await entityStore.getToken())}` });
      const response = await fetch(amplitudeImageHref, { headers });
      const dataUrl = URL.createObjectURL(await new Response(response.body).blob());
      setImageSrc(dataUrl);
    };
    if (amplitudeImageHref) {
      fetchData();
    }
  }, [amplitudeImageHref]);

  // clear the imageSrc when the levelEntity changes, so we don't have a stale image
  useEffect( function cleanup() {
    return () => setImageSrc(undefined);
  }, [levelEntity]);

  return imageSrc;
}

export function useLatestBinLevelImageSrc({ binId }) {
  // const { entity: binEntity } = useSirenEntity({ href: binId });
  // const { entity: latestBinLevelEntity } = useSirenEntity({ href: binEntity?.getSubEntityByRel('https://api.binsentry.com/rel/bin-level-latest')?.href });
  const { entity: levelEntity } = useLatestLevelFromPageNow({ binHref: binId });

  return useBinLevelImageSrc({ levelEntity });
}
